export default "__VITE_ASSET__a5620605__"